import { Button, type ButtonProps } from "@/design-system";
import { trackEvent, type WhatsappCtaLocation } from "@/lib/dataLayer";
import { WHATSAPP_HREF } from "../constants";

type WhatsAppLinkButtonProps = {
  /** Onde o CTA está na página — vai para o evento `cta_click_whatsapp`. */
  location: WhatsappCtaLocation;
  variant?: ButtonProps["variant"];
};

/**
 * Link para o WhatsApp com cara de botão. É um `<a>` de verdade (via `asChild`),
 * nunca um `<button>` dentro de `<a>`: interativo aninhado é HTML inválido e o
 * leitor de tela anuncia dois controles para um clique só.
 */
export const WhatsAppLinkButton = ({
  location,
  variant = "secondary",
}: WhatsAppLinkButtonProps) => (
  <Button asChild variant={variant} size="lg" navigates="external">
    <a
      href={WHATSAPP_HREF}
      target="_blank"
      rel="noopener noreferrer"
      onClick={() => trackEvent({ event: "cta_click_whatsapp", location })}
    >
      Falar no WhatsApp
    </a>
  </Button>
);
